import React from 'react';

import { Icon } from '../Icon/Icon';
import { Root, Pill, Vs } from './StatBadge.styles';

export type StatBadgeProps = {
  change: string;
  changeType: 'increase' | 'decrease';
  vs: string;
  /** Which direction reads as positive (green). Defaults to 'increase' (more is
   * better). The CPA card passes 'decrease' — a falling cost is the good outcome. */
  positiveWhen?: 'increase' | 'decrease';
  /** The figure did not move. `changeType` still has to name a direction, and neither one is
   * true here, so this overrides both the arrow and the tint: a steady figure reads as steady
   * rather than as a rise (or, on an inverted card, as a fall) of zero. */
  flat?: boolean;
};

/** "▲ +4.5%  vs yesterday" — a tinted delta pill + a muted comparison label. */
export const StatBadge = ({
  change,
  changeType,
  vs,
  positiveWhen = 'increase',
  flat = false,
}: StatBadgeProps): React.ReactElement => {
  const sentiment = flat ? 'neutral' : changeType === positiveWhen ? 'positive' : 'negative';
  return (
    <Root>
      <Pill $sentiment={sentiment}>
        <Icon name={flat ? 'minus' : changeType === 'increase' ? 'trending-up' : 'trending-down'} size={10} />
        {change}
      </Pill>
      <Vs text={vs} tag="span" />
    </Root>
  );
};

export default StatBadge;
